import React, { useEffect, useState } from "react";
import TransactionOTPModal from "../../../../Modals/TransactionsOTPModal";
import { NavigationButton } from "../../../../Buttons";
import CommonButton from "../../../../Buttons/CommonButton";
import FormInputField from "../../../../FormInputField";
import Label from "../../../../Label";
import TransferGifs from "../partials/TransferGifs";
import { DownArrowIcon } from "../../../../Icons";
import {
  externalTR,
  updateExternalTR,
} from "../../../../../redux/actions/TRrequest/External";
import { useDispatch } from "react-redux";
import { useDeleteDocument, useForm } from "../../../../../hooks";
import {
  FormatBalance,
  GetCurrenySymbol,
  GetValidationErrors,
} from "../../../../../helper";
import SelectBeneficiaryModal from "../../../../Modals/Beneficiary/SelectBeneficiaryModal";
import TransactionDetail from "../../../TransactionDetail";
import Review from "../../../Review";
import { verifyTROTP } from "../../../../../redux/actions/TRrequest/OTPVerification";
import CustomTransition from "../../../../CustomTransition";
import { setPageTitle } from "../../../../../helper/metaDataHelper";
import { getTransactionDetails } from "../../../../../redux/actions/Transaction/TransactionHistory";
import { setActiveAccount } from "../../../../../redux/actions/home/ActiveAccountAction";
import { useNavigate } from "react-router-dom";
import SelectAccountDropdown from "../../../../Common/SelectAccountDropdown";
import ErrorMessage from "../../../../Common/ErrorMessage";
import PreviousDocs from "../../../../Common/PreviousDocs";
import MultipleFileUpload from "../../../../MultipleFileUpload";
import { ValidateFileSize } from "../../../../../utils/ValidateFileSize";
import Dropdown from "../../../../Dropdown";
import useTransactionMethods from "../../../../../hooks/useTransactionMethods";
import usePaymentTypes from "../../../../../hooks/usePaymentTypes";

const ExternalTransfer = ({
  accounts,
  activeAccount,
  handlePrev,
  handleNext,
  setStep,
  step,
  setIsTransactionConfirmed,
  isTransferConfirmed,
  beneficiary,
  location,
}) => {
  const [loading, setLoading] = useState(false);
  const [trn_id, setTrnId] = useState("");
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [beneficiaryAccount, setBeneficiaryAccount] = useState({});
  const [supportingDocument, setSupportingDocument] = useState("");
  const { documents, setDocuments, handleDeleteDocument } = useDeleteDocument(
    []
  );
  const [error, setError] = useState([]);

  const fromAccount = useForm(activeAccount);
  const amount = useForm("", "amount");
  const remarks = useForm("");
  const transferType = useForm("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [fileValidationError, setFileValidationError] = useState(false);
  // eslint-disable-next-line
  const [transactionType, getMethodBylable] = useTransactionMethods(setLoading);
  const [selectedType, setSelectedType] = useState("");
  const [paymentType, getPaymentBylable] = usePaymentTypes(setLoading);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");

  useEffect(() => {
    setPageTitle("External Transfer");
  }, []);

  useEffect(() => {
    if (beneficiary && beneficiary.id) {
      setBeneficiaryAccount(beneficiary);
      if (beneficiary.account_currency) {
        const account = accounts.find(
          (acc) => acc.currency_id === beneficiary.account_currency
        );
        fromAccount.setValue(account);
      }
    }
    // eslint-disable-next-line
  }, [beneficiary]);

  useEffect(() => {
    // get transaction details
    const fetchTransactionDetails = async () => {
      setLoading(true);
      const data = {
        trn_id: location.state.transaction.id,
        transaction_nature: "TT",
      };
      const res = await dispatch(getTransactionDetails(data));
      if (res.success) {
        amount.setValue(res.data.amount);
        remarks.setValue(res.data.remarks);
        setBeneficiaryAccount(res.data.beneficiary);

        if (res.data.docs && res.data.docs.length > 0) {
          setDocuments(res.data.docs);
        }
      }
      setLoading(false);
    };
    if (location.state && location.state.transaction) {
      fetchTransactionDetails();
    }
  }, [location.state, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!activeAccount.is_sepa) {
      setLoading(true);
      setSelectedType("SWIFT");
      const method = getMethodBylable("SWIFT");

      if (method) {
        transferType.setValue(method.id);
      }

      setLoading(false);
    } else {
      setSelectedType("");
      transferType.setValue("");
    }
    // eslint-disable-next-line
  }, [activeAccount]);

  const handleChangeFromAccount = async (account) => {
    fromAccount.setValue(account);
    if (error || fromAccount.error) {
      setError("");
      fromAccount.setError("");
    }
    // Ensure beneficiary account resets properly when switching accounts
    if (
      !beneficiaryAccount ||
      beneficiaryAccount.account_currency !== account.currency_id
    ) {
      setBeneficiaryAccount({});
      transferType.setValue("");
    }
  };

  const handleExternalTransfer = async () => {
    setLoading(true);
    setIsOTPModalOpen(true);
    const today = new Date();
    const formData = new FormData();
    formData.append("account_id", fromAccount.value.id);
    formData.append("beneficiary_id", beneficiaryAccount.id);
    formData.append("amount", amount.value);
    formData.append("remarks", remarks.value);
    formData.append("transfer_type", transferType.value);
    formData.append("transaction_date", today.toISOString().split("T")[0]);
    formData.append("payment_type_id", selectedPaymentType);

    if (transferType.value) {
      formData.append("transaction_method_id", transferType.value);
    } else {
      const method = getMethodBylable("SWIFT");
      formData.append("transaction_method_id", method.id);
    }

    if (supportingDocument) {
      Object.keys(supportingDocument).forEach((key) => {
        supportingDocument[key].forEach((file) => {
          formData.append("supporting_documents[]", file);
        });
      });
    }

    let res;

    try {
      if (location.state && location.state.transaction) {
        formData.append("trn_id", location.state.transaction.id);
        res = await dispatch(updateExternalTR(formData));
      } else {
        res = await dispatch(externalTR(formData));
      }

      if (res.success) {
        setTrnId(res.data.trn_id);
        setLoading(false);
        setIsOTPModalOpen(true);
        setIsTransactionConfirmed(true);
        setStep(3);
        location.state = null;
        return;
      } else if (!res.success) {
        if (res.errors) {
          setError(GetValidationErrors(res.errors));
        } else {
          setError(res.error);
        }
        setStep(2);
        setIsOTPModalOpen(false);
        setTimeout(() => {
          setLoading(false);
        }, 500);
        return;
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      setIsOTPModalOpen(false);
      setStep(2);
    }
  };

  const validateExternal = () => {
    let validate = true;
    setError([]);
    
    if (
      fromAccount.value.balance <= 0 ||
      fromAccount.value.balance < amount.value
    ) {
      validate = false;
      fromAccount.setError("Insufficient balance in this account.");
      amount.setError(true);
    }

    if (amount.validate()) {
      validate = false;
      amount.setError("Please enter a valid amount.");
    }

    if (!remarks.value) {
      validate = false;
      remarks.setError("Please enter a remark.");
    }

    if (!selectedPaymentType) {
      validate = false;
      setError("Please select transaction type.");
    }

    if (!supportingDocument && documents.length === 0) {
      validate = false;
      setError("Please upload a supporting document");
    }

    setStep(2);

    return validate;
  };

  const handleFileChange = (name, selectedFiles) => {
    const sizeErrors = [];

    Array.from(selectedFiles).forEach((file) => {
      const { isValid, error } = ValidateFileSize(file);
      if (!isValid) {
        sizeErrors.push(error);
      }
    });

    if (sizeErrors.length > 0) {
      setError(sizeErrors);
      setFileValidationError(true);
      return;
    }

    setSupportingDocument((prevFiles) => {
      const updatedFiles = { ...prevFiles, [name]: selectedFiles };
      if (!selectedFiles.length) {
        delete updatedFiles[name];
        return "";
      }
      return updatedFiles;
    });
    setFileValidationError(false);
    if (error) {
      setError([]);
    }
  };

  const handleContinue = () => {
    if (!validateExternal()) return;
    handleNext();
  };

  const handleViewTransaction = async () => {
    setIsOTPModalOpen(false);
    setStep(1);
    navigate("/all-transactions");
    await dispatch(setActiveAccount(fromAccount.value));
  };

  return (
    <div className="min-h-screen">
      {step === 2 && (
        <div className="md:w-[400px] space-y-4">
          {error.length > 0 && (
            <ErrorMessage message={error} onClose={() => setError("")} />
          )}

          <div className="space-y-4">
            <div className="space-x-3">
              <span className="transaction-page-title text-sm font-normal tracking-tight">
                You’re have
              </span>
              <span
                className={`transaction-page-balance-text text-sm font-bold tracking-tight
                ${fromAccount.value.balance <= 0 && "text-error-500"}
                `}
              >
                {FormatBalance(fromAccount.value.balance)}{" "}
                {fromAccount.value.currency_code}
              </span>
            </div>

            <div className="space-y-3">
              <Label
                className="common-transaction-lable text-sm font-medium tracking-tight"
                text={"From account"}
              />
              <SelectAccountDropdown
                title={"From account"}
                accounts={accounts}
                slectedAccount={fromAccount.value}
                setAccount={handleChangeFromAccount}
              />

              {fromAccount.error && (
                <span className="text-error-500 text-sm px-2">
                  {fromAccount.error}
                </span>
              )}

              {/* {fromAccount.value.is_sepa && (
                <div>
                  <Dropdown
                    id="transferType"
                    name="transferType"
                    placeholder="Select a transfer type"
                    label="Transfer Type"
                    options={transactionType}
                    onChange={(e) => {
                      transferType.setValue(e.target.value);
                      const selectedOption = transactionType.find(
                        (option) => option.value === e.target.value
                      );
                      setSelectedType(
                        selectedOption ? selectedOption.label : ""
                      );
                    }}
                    value={transferType.value}
                  />
                </div>
              )} */}
            </div>

            <TransferGifs />

            <div className="space-y-3">
              <Label
                className="common-transaction-lable text-sm font-medium tracking-tight"
                text={"To account"}
              />

              <SelectBeneficiaryModal
                setBeneficiaryAccount={setBeneficiaryAccount}
                beneficiaryAccount={beneficiaryAccount}
                fromAccount={fromAccount.value}
                transferMethod={selectedType}
              >
                <FormInputField
                  key={beneficiaryAccount?.id || Math.random()} // Ensures re-render when empty
                  label={"Beneficiary account"}
                  placeholder="Select Beneficiary account"
                  type="text"
                  readOnly={true}
                  value={beneficiaryAccount?.name}
                  icon={<DownArrowIcon />}
                  error={error.accountNumberError}
                />
              </SelectBeneficiaryModal>
            </div>

            <CustomTransition show={beneficiaryAccount.id ? true : false}>
              <div className="space-y-3">
                <div>
                  <FormInputField
                    label="Amount"
                    placeholder="Enter Amount"
                    type="number"
                    {...amount}
                    currency={GetCurrenySymbol(
                      fromAccount.value.currency_code.split(" ")[0],
                      "13",
                      "13"
                    )}
                  />
                </div>
                <div>
                  <FormInputField
                    label="Remarks"
                    placeholder="Add Note"
                    type="text"
                    {...remarks}
                  />
                </div>

                <div>
                  <Dropdown
                    id="paymentType"
                    name="paymentType"
                    placeholder="Select a transaction type"
                    label="Transaction Type"
                    options={paymentType}
                    onChange={(e) => {
                      setSelectedPaymentType(e.target.value);
                    }}
                    value={selectedPaymentType}
                  />
                </div>

                <div>
                  <MultipleFileUpload
                    name="supporting_documents"
                    id="supporting_documents"
                    title={"Supporting document"}
                    onChange={handleFileChange}
                    isMultiple={true}
                    maxCount={5}
                    mandatory={true}
                    files={files}
                    setFiles={setFiles}
                  />
                  <PreviousDocs
                    documents={documents}
                    handleDeleteDocument={handleDeleteDocument}
                  />
                  {error.supportingDocument && (
                    <span className="text-error-500 text-sm px-2">
                      {error.supportingDocument}
                    </span>
                  )}
                </div>
              </div>
            </CustomTransition>
          </div>

          <hr className="border border-divider" />

          <div className="flex space-x-4">
            <NavigationButton text={"Back"} onClick={handlePrev} />
            <CommonButton
              disabled={
                !amount.value ||
                !remarks.value ||
                fileValidationError ||
                (!supportingDocument && documents.length === 0) ||
                !beneficiaryAccount.id
              }
              onClick={handleContinue}
            >
              Continue
            </CommonButton>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="md:w-[568px]">
          <Review
            supportingDocument={supportingDocument}
            handlePrev={handlePrev}
            handleTransaction={handleExternalTransfer}
            amount={`${amount.value} ${fromAccount.value.currency_code}`}
            message=" will be transferred to the below account details."
            isTransactionConfirmed={isTransferConfirmed}
          >
            <TransactionDetail
              label="You’re sending"
              value={`${amount.value} ${fromAccount.value.currency_code}`}
            />
            <TransactionDetail label="Nature" value="External Transfer" />

            <hr className="flex w-full border-divider" />
            <TransactionDetail
              label="From account"
              value={`${fromAccount.value.title}`}
            />

            <TransactionDetail
              label="Recipient account name"
              value={beneficiaryAccount.name}
            />
            <TransactionDetail
              label="Recipient account number"
              value={beneficiaryAccount.account_number}
            />

            <hr className="flex w-full border-divider" />

            <TransactionDetail label="Remarks" value={remarks.value} />
            <TransactionDetail
              label="Transaction type"
              value={getPaymentBylable(selectedPaymentType)}
            />
          </Review>
        </div>
      )}

      <TransactionOTPModal
        isLoading={loading}
        setisLoading={setLoading}
        TrnId={trn_id}
        setTrnId={setTrnId}
        isModalOpen={isOTPModalOpen}
        setIsModalOpen={setIsOTPModalOpen}
        handleTransaction={handleExternalTransfer}
        reduxaction={verifyTROTP}
        navigateUrl="/"
        handleViewTransaction={handleViewTransaction}
      />
    </div>
  );
};

export default ExternalTransfer;
